import React from "react";
import { Notification } from "common/components/ui";
import { Appearance } from "common/components/ui/shared";
import { FormattedMessage } from "common/components/ui/FormattedMessage";
import { SIMPLE_PREP_PAGE_LABELS } from "./SimplePrepPage.labels";

export const MinPrepFeesNotification = () => {
  return (
    <Notification
      appearance={Appearance.INFO}
      content={{
        title: FormattedMessage({ ...SIMPLE_PREP_PAGE_LABELS.minPrepFeeNotificationTitle }),
        description: <FormattedMessage {...SIMPLE_PREP_PAGE_LABELS.minPrepFeeNotificationDescription} />,
      }}
    />
  );
};
